import request from '@/utils/request'

// 获取动态路由菜单
export const getMenuRoutes = () => {
  return request({
    url: '/uic-system/menu/routes',
    method: 'GET'
  })
}
